<template>
    <v-row no-gutters>
        <v-col cols="12">
        <v-card tile outlined v-if="typeof this.babyData != 'undefined'">
            <v-row dense>
                <v-col cols="12" lg="6" xl="6" class="text-left">
                    <span> Bem Vinda <b>Mamãe</b> {{this.babyData.FirstNameMamae}}</span>
                    <span v-if="typeof this.babyData.nomePapai != 'undefined'"> e <b>Papai</b> {{this.babyData.FirstNamePapai}} </span>                            
                </v-col>
                <show-at breakpoint="mediumAndBelow">
                    <v-col cols="12" lg="6" xl="6" class="text-left">
                        <countdown :time="this.contagem">
                            <template slot-scope="props"><b>Faltam：</b>{{ props.days }} dias, {{ props.hours }} horas, {{ props.minutes }} minutos, {{ props.seconds }} segundos para sua Revelação</template>
                        </countdown>                            
                    </v-col>
                </show-at>
                <show-at breakpoint="mediumAndAbove">
                    <v-col cols="12" lg="6" xl="6" class="text-right">
                        <countdown :time="this.contagem">
                            <template slot-scope="props"><b>Faltam：</b>{{ props.days }} dias, {{ props.hours }} horas, {{ props.minutes }} minutos, {{ props.seconds }} segundos para sua Revelação</template>
                        </countdown>                            
                    </v-col>                            
                </show-at>
            </v-row>
        </v-card>
        </v-col>
    </v-row>
</template>
<script>
import {showAt} from 'vue-breakpoints'
import { db } from '@/main'

export default {
    components: { showAt },
    // props: ['babyData', 'contagem'],
    data: () => ({
       babyData : {
          FirstNameMamae: "Maria Joana",
          FirstNamePapai: "José Maria" 
       }, 
       contagem: "112311230000"
    }),
    async created(){
        this.url = sessionStorage.getItem('accessCode')
        this.loggedIn = sessionStorage.getItem('loggedIn')
        await setTimeout(() => {}, 5000);
        await db.collection('revelacoes').where('URL','==',this.url).get()
        .then((seg) => {    
            this.babyData = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a})[0];
            this.listaPresentes = this.babyData.listaPresentes || []
            this.contagem = this.babyData.dataRevelacao - new Date().getTime()
            this.contagem = this.contagem < 0 ? 0 : this.contagem
            
            
            let nomePai = this.babyData.nomeMamae
            let nomeMae = this.babyData.nomePapai

            this.babyData.FirstNameMamae =  nomePai.substring(0, nomePai.indexOf(" "))
            this.babyData.FirstNamePapai =  nomeMae.substring(0, nomeMae.indexOf(" "))  

        }).catch(function (error) {
            this.loading = false
            console.error("Error get userss: ", error);
        });              
    },      
}
</script>